import React from 'react';

import withAppState from '../mobx/withAppState'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import SwipeableContainer from '../components/Swipeable';

class ErrorModal extends React.Component {
  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (e) => {
    if (this.wrapperRef && !this.wrapperRef.contains(e.target)) {
      this.handleClose()
    }
  }
  
  
  handleClose = () => {
    if (this.props.errorModalEnabled === true) {
      this.props.disableErrorModal()
    }
  }

  
  setWrapperRef = (node) => {
    this.wrapperRef = node;
  }
  
  render() {
    const elementClose = <FontAwesomeIcon icon={faTimes} />
    const { errorModalEnabled, errorModalTitle, errorModalMessage, errorModalTitleBackground } = this.props
    return (
      <>
      <div className={`modal-slide-bg ${(errorModalEnabled === true) ? 'active' : ''}`} onClick={() => { this.handleClose() }}></div>
      <SwipeableContainer handleModalCancel={() => this.handleClose()} slideUpModal={errorModalEnabled}>
        {/* <div id="errorModal" ref={this.setWrapperRef} className={`error-modal ${(this.props.errorModalEnabled === true) ? 'active' : ''}`}>
          <div className="close-wrapper" onClick={() => {this.handleClose()}}>
            {elementClose}
          </div>
          <div className="error-content">
            <p>{this.props.errorModalMessage}</p>
          </div>
        </div> */}
        <div ref={this.setWrapperRef} className="error-modal-inner modal-slide-up-inne-error">
          <div className="modal-slide-up-content">
            <div className="modal-content-inner">
              <div className={`modal-header has-background-icon ${errorModalTitleBackground ? errorModalTitleBackground : 'error'}`}>
                <h3>{errorModalTitle ? errorModalTitle : 'Error'}</h3>
              </div>
              {errorModalMessage && <div className="modal-content">
                <p>{errorModalMessage}</p>
              </div>}

              <div className="modal-button-container is-column small-btns">
                <div className="btn-container">
                  <button
                    className={`btn btn-secondary`}
                    onClick={() => { this.handleClose() }}
                  >

                    <span>Close</span>
                  </button>
                </div>
              </div>



            </div>
          </div>
        </div>
      </SwipeableContainer>
      </>
    );
  }
}

export default withAppState(ErrorModal,
  {
    mobXProps: ({
      errorModalEnabled,
      errorModalMessage,
    }) => ({
      errorModalEnabled,
      errorModalMessage,
    }),
    mobXActions: ({ 
      disableErrorModal,
    }) => ({
      disableErrorModal,
    })
  }
);
